// extracted by mini-css-extract-plugin
module.exports = {"navEntry":"NavigationEntry_navEntry__m1sEF","active":"NavigationEntry_active__12sRn","icon":"NavigationEntry_icon__1Yzsv","label":"NavigationEntry_label__3_3js"};